import { render, staticRenderFns } from "./MemberGradeIframe.vue?vue&type=template&id=105fb2e9&"
import script from "./MemberGradeIframe.vue?vue&type=script&lang=ts&"
export * from "./MemberGradeIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports